import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=f57506b6&scoped=true&"
import script from "./AttributeTable.vue?vue&type=script&lang=js&"
export * from "./AttributeTable.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTable.vue?vue&type=style&index=0&id=f57506b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57506b6",
  null
  
)

export default component.exports